// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
var partial$0 = require('./_accordionWidgetTriggerTemplate.hbs');
HandlebarsCompiler.registerPartial('./_accordionWidgetTriggerTemplate.hbs', partial$0);
var partial$1 = require('./_accordionWidgetContentTemplate.hbs');
HandlebarsCompiler.registerPartial('./_accordionWidgetContentTemplate.hbs', partial$1);
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"./_accordionWidgetTriggerTemplate.hbs"),depth0,{"name":"./_accordionWidgetTriggerTemplate.hbs","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"./_accordionWidgetContentTemplate.hbs"),depth0,{"name":"./_accordionWidgetContentTemplate.hbs","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
